import { Button, message, Modal } from 'antd/lib';
import { useState } from 'react';
import { SyncOutlined } from '@ant-design/icons';

function getRevalidateUrl() {
  const { protocol, hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }
  const frontendHostname = hostname
    .replace('staging.app.', 'staging.')
    .replace('app.', 'www.');
  const baseUrl = `${protocol}//${frontendHostname}/api/revalidate`;
  return `${baseUrl}?token=wb_cache_revalidate_24`;
}

export const RevalidateWebixCache = () => {
  const [loading, setLoading] = useState(false);

  const onClick = async function () {
    Modal.confirm({
      title: 'Are you sure you want to revalidate Webix cache?',
      okText: 'Revalidate',
      onOk: async () => {
        setLoading(true);
        try {
          const revalidateUrl = getRevalidateUrl();
          if (!revalidateUrl) {
            message.info(
              'Skipping cache invalidation, as environment is local.'
            );
            setLoading(false);
            return;
          }
          const response = await fetch(revalidateUrl);
          if (response.ok) {
            message.success('Webix cache revalidated successfully');
          } else {
            message.error('Failed to revalidate Webix cache');
          }
        } catch (error) {
          console.error(error);
          message.error('Failed to revalidate Webix cache, Please try again');
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <Button
      onClick={onClick}
      loading={loading}
      type="primary"
      icon={<SyncOutlined spin={loading} />}
    >
      Revalidate Webix Cache
    </Button>
  );
};
